import classNames from 'classnames';
import { AsyncStatus } from 'lib-shared-types-api';
import type {
  PropsWithChildren,
  PropsWithClassName,
} from 'lib-shared-types-utils';
import ReactDropzone, {
  DropzoneProps as ReactDropzoneProps,
} from 'react-dropzone';

import styles from './dropzone.module.scss';

type DropzoneProps = {
  /** The status of the upload request. */
  status?: AsyncStatus;
} & ReactDropzoneProps &
  PropsWithClassName &
  PropsWithChildren;

export const Dropzone = ({
  className,
  children,
  status,
  ...dropzoneProps
}: DropzoneProps): JSX.Element => {
  const rootClass = classNames(
    {
      [styles.dropzone]: true,
      [styles.dropzoneActive]: status === 'pending',
      [styles.dropzoneFulfilled]: status === 'fulfilled',
      [styles.dropzoneRejected]: status === 'rejected',
    },
    className,
  );

  return (
    <ReactDropzone
      className={rootClass}
      activeClassName={styles.dropzoneActive}
      rejectClassName={styles.dropzoneRejected}
      {...dropzoneProps}
    >
      {children}
    </ReactDropzone>
  );
};
